/**
 * Author: Lakshman Veti
 * Type: Service
 * Objective: Serve common functionality accross applicaion
 * Associated Route/Usage: Global
 */

 import config from "../config";
 import moment from "moment";
 import CONSTANTS from "../data/constants";
 import CategoryMasterService from "./categoryMasterService";
 import impaCategoryMasterServices from "./impaCategoryMasterService";
import ExportLineItemValues from "src/data/constants/exportLineItemValues";
 
 const commonService = {
   loading: false,
   restCall,
   getJsonHeaders,
   handleResponse,
   getOptionFromList,
   clone,
   getFormattedDate,
   constructListOptions,
   objToParams,
   isPastDate,
   isDirty,
   getParamId,
   replaceJSONNullVals,
   getStatusFromList,
   getDateRange,
   filterItems,
   doSum,
   addElipsis,
   correctSerialNumber,
   getAllUrlParams,
   regExComparison,
   regExNumaric,
   duprestCall,
   formMenuJSON,
   setFieldBaseOrderType,
   setUTC_Time,
   roundTo,
   checkDuplicateCode,
   getAllFilteredImpaCodes,
   decimalToNumber,
   ManipulateValue,
   getRoleIdByCode,
   exportDataMapping,
   allMastersFilteration,
   objectIdFilter,
   trimLineBreakFromString,
   removeWhiteSpaces,
   tokenGenerator,
   emailValidation,
 };
 
 /**
  * common REST call
  * @options : object (properties needed for REST call)
  */
 function restCall(options) {
  const requestOptions = {
    method: options.method,
    headers: commonService.getJsonHeaders(options.headers,options),
    body: JSON.stringify(options.data),
    redirect: "follow",
  };

  return fetch(options.url, requestOptions)
    .then(commonService.handleResponse)
    .then((data) => {
      // console.log('response..'+data);
      return data;
    }).catch(async (err) => {
      // Logout when inActive user attempts any action 
      if (err?.error?.isActiveUser === 0) {
        localStorage.clear();
        window.location = "#/login";
        localStorage.setItem('inValidUser', 1);
      }
      throw err;
    });
}
 
 function duprestCall(options) {
   const requestOptions = {
     method: options.method,
     headers: commonService.getJsonHeaders(options.headers),
     body: JSON.stringify(options.data),
     redirect: "follow",
   };
 
   return fetch(options.url, requestOptions)
     .then(commonService.dupHandleResponse)
     .then((data) => {
       return data;
     })
     .catch((err)=>{
       throw err;
     });
 }
 
 function dupHandleResponse(response) {
   return response.text().then((text) => {
     const data = text //&& JSON.parse(text);
     if (data ){//&& data.status == "OK") {
       return data;
     } else {
       //if(doLogOut) logout();
       const error =
         (data && data.error && data.error.message) || response.statusText;
       // return Promise.reject(data.error);
       return Promise.reject(data);
     }
   });
 }
 
 
 /**
  * REST response handler
  * @response : xhr object
  */
 function handleResponse(response) {
   return response.text().then((text) => {
     const data = text && JSON.parse(text);
     if (data && data.status == "OK") {
       return data;
     } else {
       //if(doLogOut) logout();
       const error =
         (data && data.error && data.error.message) || response.statusText;
       // return Promise.reject(data.error);
       return Promise.reject(data);
     }
   });
 }
 
 /**
  * Construct HTTP headers
  * @void
  */
function getJsonHeaders(customHeaders, apiParams) {
  let headers = new Headers();
  const isTokenRequired = apiParams?.url?.includes('authenticate');
  headers.append("Content-Type", "application/json");
  headers.append("Access-Control-Allow-Headers", "Authorization");
  headers.append("Access-Control-Allow-Origin", "*");
  headers.append("mode", "no-cors");
  headers.append("branchId", "1");
  // if (!isTokenRequired) {
  //   const token = localStorage.getItem("token");
  //   headers.append('authorization', "Bearer " + token);
  // }
  if (customHeaders) {
    for (let [key, value] of Object.entries(customHeaders)) {
      var el = Object.keys(value);
      for (var i in el) {
        headers.append(el[i], value[el]);
      }
      //
    }
  }
  if (localStorage.getItem("user")) {
    var user = JSON.parse(localStorage.getItem("user"));
    if (user.data) {
      headers.append("userCode", user.data.userCode);
      headers.append("roleId", user.data.roleId);
      headers.append("objectId", user.data.objectId);
      // if (user.data) {
      // }
    }
  }
  return headers;
}
 
 /**
  * Return index/object from array list based on passed value
  * @list  : array
  * @value : string
  * @ret   : string
  */
 function getOptionFromList(list, value, ret, key, obj, optionKey) {
   var opt,
     ind,
     key = key ? key : "value",
     exist = false;
   for (var i in list) {
     //if(key == 'requestedUOMId')
     if (list[i][key] == value) {
       opt = list[i];
       ind = i;
       exist = true;
       break;
     }
   }
 
   const opKey = optionKey ? optionKey : "value";
   //setting back id value from list option object
   // ex: set employeeId from employeeIdSelectionOption
   if (obj && obj.scope && obj.id && ret == "obj" && opt && opt[opKey]) {
     obj.scope[obj.id] = opt[opKey];
   }
 
   switch (ret) {
     case "index":
       return ind;
       break;
     case "obj":
       return opt;
       break;
     case "flag":
       return exist;
       break;
   }
 }
 
 /**
  * Deep clone object
  * @obj  : obj
  */
 function clone(obj) {
   return JSON.parse(JSON.stringify(obj));
 }
 
 /**
  * Format date to dd/mm/yyyy
  * @date  : Date
  */
 function getFormattedDate(date, format) {
   var fdate = "";
   switch (format) {
     case "yyyymmdd":
       fdate = [
         date.getFullYear(),
         ("0" + (date.getMonth() + 1)).slice(-2),
         ("0" + date.getDate()).slice(-2),
       ].join("-");
       break;
     case "yyyymmdd:hh:mm":
       fdate = [
         date.getFullYear(),
         ("0" + (date.getMonth() + 1)).slice(-2),
         ("0" + date.getDate()).slice(-2),
       ].join("-");
       fdate += " : " + date.getHours() + ":" + date.getMinutes();
       break;
     case "yyyymmdd:hh:mm:ss":
       fdate = [
         date.getFullYear(),
         ("0" + (date.getMonth() + 1)).slice(-2),
         ("0" + date.getDate()).slice(-2),
       ].join("-");
       fdate +=
         " " +
         date.getHours() +
         ":" +
         date.getMinutes() +
         ":" +
         date.getSeconds();
       break;
     case "yyyymmddThh:mm":
       fdate = [
         date.getFullYear(),
         ("0" + (date.getMonth() + 1)).slice(-2),
         ("0" + date.getDate()).slice(-2),
       ].join("-");
       fdate += "T" + date.toTimeString().slice(0, 5);
       break;
     case "mmddyyyy":
       var year = date.getFullYear();
 
       var month = (1 + date.getMonth()).toString();
       month = month.length > 1 ? month : "0" + month;
 
       var day = date.getDate().toString();
       day = day.length > 1 ? day : "0" + day;
 
       fdate = month + "/" + day + "/" + year;
       break;
     case "ddmmyyyy":
       var year = date.getFullYear();
 
       var month = (1 + date.getMonth()).toString();
       month = month.length > 1 ? month : "0" + month;
 
       var day = date.getDate().toString();
       day = day.length > 1 ? day : "0" + day;
 
       fdate = day + "/" + month + "/" + year;
       break;
     case "dd-mm-yyyy":
       var year = date.getFullYear();
 
       var month = (1 + date.getMonth()).toString();
       month = month.length > 1 ? month : "0" + month;
 
       var day = date.getDate().toString();
       day = day.length > 1 ? day : "0" + day;
 
       fdate = day + "-" + month + "-" + year;
       break;
     case "yyyy-mm-dd":
       var year = date.getFullYear();
 
       var month = (1 + date.getMonth()).toString();
       month = month.length > 1 ? month : "0" + month;
 
       var day = date.getDate().toString();
       day = day.length > 1 ? day : "0" + day;
 
       fdate = year + "-" + month + "-" + day;
       break;
   }
   return fdate;
 }
 
 /**
  * Construct list options from passed array
  * @list   : Arra   y
  * @fields : Array
  *  Ex fields: {label:impaCode, value:impaName}
  */
 
 function constructListOptions(list, fields) {
   var obj = [];
   //list = list.data;
   for (var i in list) {
     var item = {};
     for (const [key, value] of Object.entries(fields)) {
       item[key] = list[i][value];
     }
     obj.push(item);
   }
   return obj;
 }
 
 /**
  * Constructs query params from an object
  * @obj   : object
  */
 function objToParams(obj) {
   let str =
     "?" +
     Object.keys(obj)
       .reduce(function (a, k) {
         a.push(k + "=" + encodeURIComponent(obj[k]));
         return a;
       }, [])
       .join("&");
   return str;
 }
 
 /**
  * Returns boolean if the given date is past
  * @selectedDate   : date in string
  * #comparableDate : date in string
  */
 function isPastDate(selectedDate, comparableDate) {
   var CurrentDate = new Date();
   if (comparableDate) CurrentDate = new Date(comparableDate);
   selectedDate = new Date(selectedDate);
   selectedDate.setHours(0, 0, 0, 0);
   CurrentDate.setHours(0, 0, 0, 0);
   return selectedDate < CurrentDate ? true : false;
 }
 
 function isDirty(oldArray, newArray) {
   var changes, i, item, j, len;
   if (JSON.stringify(oldArray) === JSON.stringify(newArray)) {
     return false;
   }
   changes = [];
   for (i = j = 0, len = newArray.length; j < len; i = ++j) {
     item = newArray[i];
     if (JSON.stringify(item) !== JSON.stringify(oldArray[i])) {
       changes.push(item);
     }
   };
   return changes.length > 0 ? true : false;
 }
 
 /**
  * Returns url hash param value
  * @url   : current url string
  * @slug :  comparable string
  */
 function getParamId(url, slug) {
   var strRegExPattern = slug + "/([0-9]+)";
   var match = url.match(new RegExp(strRegExPattern, "g"));
   if (match && match.length > 0) return match[0].replace(slug + "/", "");
   return "";
 }
 
 /**
  * Replacs nulls in json objects and returns
  * @data   : JSON Obj
  */
 function replaceJSONNullVals(data) {
   try {
     return JSON.parse(JSON.stringify(data).replace(/\:null/gi, ':""'));
   } catch (e) {
     return data;
   }
 }
 
 function getStatusFromList(list, column, status) {
   var arr = [];
   //list = list.data;
   for (var i in list) {
     if (list[i][column] == status) arr.push(list[i]);
   }
   return arr;
 }
 
 function getDateRange(pastCount, futureCount) {
   const startDate = new Date(new Date().getMonth() - 1);
   const endDate = new Date(new Date().getMonth);
   const formattedStartDate = moment(this.startDate)
     .startOf("month")
     .subtract("2", "Months")
     .format("YYYY-MM-DD");
   const formattedEndDate = moment().clone().endOf("month").format("YYYY-MM-DD");
 
   return [formattedStartDate, formattedEndDate];
 }
 
 function filterItems(list, key, value) {
   let items = [];
   items = list.filter((item) => {
     return item[key] == value;
   });
   return items;
 }
 
 function doSum(arr, field) {
   try {
     var sum = 0;
     for (var i in arr) {
       sum += Number(arr[i][field]);
     }
     return Number(sum).toFixed(CONSTANTS.DECIMAL_VALUE);
   } catch (e) {
     console.log(e);
   }
 }
 
 function addElipsis(str, limit) {
   return str?.substring(0, limit) + (str?.length > limit ? "..." : "");
 }
 
 function correctSerialNumber(list, maxNo) {
   let count = maxNo ? maxNo : 1;
   list = list.filter((item) => {
     if (!maxNo && item.status !== "Deleted") {
       item.serialNo = count;
       item.itemNo = count;
       count++;
       return true;
     } else {
       if (item.requisitionId && item.requisitionNo) {
         return true;
       } else if (item.status !== "Deleted") {
         item.serialNo = count;
         item.itemNo = count;
         count++;
         return true;
       }
     }
   });
 
   return list;
 }
 
 function getAllUrlParams(url) {
   // get query string from url (optional) or window
   var queryString = url ? url.split("?")[1] : window.location.search.slice(1);
 
   // we'll store the parameters here
   var obj = {};
 
   // if query string exists
   if (queryString) {
     // stuff after # is not part of query string, so get rid of it
     queryString = queryString.split("#")[0];
 
     // split our query string into its component parts
     var arr = queryString.split("&");
 
     for (var i = 0; i < arr.length; i++) {
       // separate the keys and the values
       var a = arr[i].split("=");
 
       // set parameter name and value (use 'true' if empty)
       var paramName = a[0];
       var paramValue = typeof a[1] === "undefined" ? true : a[1];
 
       // (optional) keep case consistent
       paramName = paramName.toLowerCase();
       if (typeof paramValue === "string") paramValue = paramValue.toLowerCase();
 
       // if the paramName ends with square brackets, e.g. colors[] or colors[2]
       if (paramName.match(/\[(\d+)?\]$/)) {
         // create key if it doesn't exist
         var key = paramName.replace(/\[(\d+)?\]/, "");
         if (!obj[key]) obj[key] = [];
 
         // if it's an indexed array e.g. colors[2]
         if (paramName.match(/\[\d+\]$/)) {
           // get the index value and add the entry at the appropriate position
           var index = /\[(\d+)\]/.exec(paramName)[1];
           obj[key][index] = paramValue;
         } else {
           // otherwise add the value to the end of the array
           obj[key].push(paramValue);
         }
       } else {
         // we're dealing with a string
         if (!obj[paramName]) {
           // if it doesn't exist, create property
           obj[paramName] = paramValue;
         } else if (obj[paramName] && typeof obj[paramName] === "string") {
           // if property does exist and it's a string, convert it to an array
           obj[paramName] = [obj[paramName]];
           obj[paramName].push(paramValue);
         } else {
           // otherwise add the property
           obj[paramName].push(paramValue);
         }
       }
     }
   }
 
   return obj;
 }
 
function regExComparison(evaluteString, comparisonType) {
  switch (comparisonType) {
    case "discount":
      const discReg = /^\d{0,2}(\.\d{0,4})?$/;
      return discReg.test(evaluteString);
    case "twoDecimal":
      const twoDecimalReg = /^\d{0,8}(\.\d{0,2})?$/;
      return twoDecimalReg.test(evaluteString);
    case "exRate":
      const exRateReg = /^\d{0,8}(\.\d{0,7})?$/;
      return exRateReg.test(evaluteString);
      case "acceptNegativeNum":
        const acceptNegativeNum =  /^[-]?\d{0,8}(\.\d{0,2})?$/;
        return acceptNegativeNum.test(evaluteString);
       case "days":
      const Days = /^\d{0,10}?$/;
      return Days.test(evaluteString);
  }
}
 
 function regExNumaric(evaluteString, comparisonType) {
   switch (comparisonType) {
     case "discount":
       const number = /^\d{0,}(!.)?$/;
       // const number = /^\d*\.?\d+$/
       return number.test(evaluteString);
   }
 }
 
 function formMenuJSON(data){
  let expectedOutput = [];
  // const menuList = [""]/
  if(data?.length>0){
    const keys = Object.keys(data[0]);
    const dataSet = data[0];
    let item = null,
    isChildrenAvailable= false;
    for(let i in keys){
      const childContent = [];
      if(dataSet[keys[i]][0] && dataSet[keys[i]][0].childrenMenuItems){
        // const childContent = []; 
        isChildrenAvailable = true;
        dataSet[keys[i]][0].childrenMenuItems.forEach((childNav)=>{
          childContent.push({content: [childNav]})
        })  
      }else{
       isChildrenAvailable = false;
      }
      if(isChildrenAvailable){
        item = {content: [{...dataSet[keys[i]][0], children: childContent}]};
      }else{
        item = {content: [dataSet[keys[i]][0]]};
      }
      expectedOutput.push(item);
    };
  }
  return expectedOutput;
}
 
 // Setting Common field based on OrderType (Spares = PartNo/ Stores/Works = iMPACode...)
 function setFieldBaseOrderType(data,OrderType){
   for (let i in data){
     if(OrderType === CONSTANTS.ORDERTYPE.SPARES){
       data[i].code = data[i].partNo || "";
     } else if(OrderType === CONSTANTS.ORDERTYPE.STORES){
       data[i].code = data[i].iMPACode ? data[i].iMPACode : data[i].impacode || data[i].itemCode || "";
     }else{
       data[i].code = data[i].iMPACode ? data[i].iMPACode: data[i].impacode || data[i].itemCode || "";
     }
 
   }
 }
 
 function setUTC_Time(date,dateFormat){
  const UTC_Time = new Date().getTimezoneOffset() / -60;
  var UTC_Date = moment(date).subtract(UTC_Time, "hours").toDate();
  var formatedDate = moment(UTC_Date).format(dateFormat)
  return formatedDate;
 }
 
 // fix decimal value to based on parameter 
 function roundTo(value1, decimalValue,format) {
  var value = Number(value1 || 0)
  if(format === "DECIMAL"){
    return Number(Math.round(value +'e'+ decimalValue) +'e-'+ decimalValue).toFixed(decimalValue);
  }else if(format === "NUMBER"){
    var numFormat =  Number(Math.round(value +'e'+ decimalValue) +'e-'+ decimalValue).toFixed(decimalValue);
    return Number(numFormat);
  }else if(format === "CSV"){ // Comma Separated Value(CSV)
    const total = Number(Math.round(value +'e'+ decimalValue) +'e-'+ decimalValue).toFixed(decimalValue);
    const splitTotal = total.split('.',1);
    const commaValue = Number(splitTotal).toLocaleString();
    const decimalsValue = total.split('.').pop();
    return commaValue.concat('.',decimalsValue)
  }
  else{
    return Number(Math.round(value +'e'+ decimalValue) +'e-'+ decimalValue).toFixed(decimalValue);    
  }
 }

 function decimalToNumber(){
  var value = roundTo
 }

 function checkDuplicateCode (array,ResponseOrderTypeId,ImpaSelection,PartNoSelection){
  const isOrderTypeStores = ResponseOrderTypeId === CONSTANTS.ORDERTYPE.STORES;
  const isOrderTypeSpares = ResponseOrderTypeId === CONSTANTS.ORDERTYPE.SPARES;
  const isOrderTypeWorks = ResponseOrderTypeId === CONSTANTS.ORDERTYPE.WORKS;
  const SelectedId = (isOrderTypeStores || isOrderTypeWorks) ? ImpaSelection ? ImpaSelection?.associatedId : 0 : PartNoSelection ? PartNoSelection?.associatedId : 0;
  const SelectedName = (isOrderTypeStores || isOrderTypeWorks) ? "iMPACodeId" : "sparePartId";
  var Data = {
    isDuplicateCode: false,
    SerialNo: null,
    rowIndex: null,
    data: {},
  }
  // if( isOrderTypeStores || isOrderTypeSpares || isOrderTypeWorks){
  array?.find(( item, index)=>{
    if(item[SelectedName] === SelectedId){
      Data.isDuplicateCode = (SelectedId === 11042020090034 ||  SelectedId === 0 || SelectedId === undefined  ? false : true);
      Data.SerialNo = item.serialNo;
      Data.rowIndex = index;
      Data.data = item;
    }
  });
  return Data;
// }
// else{  
//   return Data;
// }
 }

 function getAllFilteredImpaCodes (e) {
  const inputValue = e.replace(/\W/g, '');
  let data = [];
  if(inputValue != ""){
  var Payload = {
    "searchString": inputValue
  }
  CategoryMasterService.getFilterdImpaCodes(10, Payload).then((res) => {
    var ActiveData = res.data.filter((item) => {
      return item.isActive === 1;
    })
    data = commonService.constructListOptions(ActiveData, {
      value: "iMPACode",
      associatedId: "iMPACodeId",
      iMPACode: "iMPACode",
      label: "iMPACategoryDescription",
      remarks: "remarks",
      uomId: "uomId",
      iMPACategoryDescription: "iMPACategoryDescription",
    });
    for (let i in data) {
      data[i].label = data[i].iMPACode ? data[i].iMPACode + " - " + data[i].label : "";
    }
  });
}
return data
}
 function ManipulateValue(data,field,value,replace){
  // ex: number === null ? "" : number
  var replacement = data.map((item)=>{
    item[field] = item[field] === value ? replace : item[field]
  })
  return replacement
 }

 function getRoleIdByCode (UsedCode){
  let UserData = ""
   impaCategoryMasterServices.getAllIMPACategories({}, CONSTANTS.TRANSACTIONID.ADMIN.USERMODULE, CONSTANTS.MODULEID.ADMIN).then((res) => {
     UserData = res.data.filter((item)=>{
      return item.userCode === UsedCode
    })
    return UserData
  });
  //  return UserData
 }

 function exportDataMapping(dataList, ExcelFields,one, two, three, four, five, six, seven, eight, nine, ten, eleven, twelve) {
  var index = [one, two, three, four, five, six, seven, eight, nine, ten, eleven, twelve];
  var reOrderedList = index.map(item => ExportLineItemValues[ExcelFields]&&ExportLineItemValues[ExcelFields][item]);

  // dataList.map((item)=>{
  //   for(let i in Object.keys(item)){
  //     if(Object.keys(item)[i].includes("Date")){
  //       item[Object.keys(item)[i]] =  Object.values(item)[i].includes("1899") || Object.values(item)[i].includes("1900") ? "" : moment(Object.values(item)[i]).format("YYYY-MM-DD")
  //     }
  //   }
  //   return item
  // });

  var modifiedData = dataList?.map((item) => {
    item.neweditDate = item.editDate?.includes("1899") || item.editDate?.includes("1900") || item.editDate === null ? "" :  moment(item.editDate).format("DD/MM/YYYY");
    item.newCreateDate = item.createDate?.includes("1899") || item.createDate?.includes("1900") || item.createDate === null ? "" : moment(item.createDate).format("DD/MM/YYYY");
      return {
          [reOrderedList[0]?.header ? reOrderedList[0].header : ""] : item[reOrderedList[0]?.field], 
          [reOrderedList[1]?.header ? reOrderedList[1].header : ""] : item[reOrderedList[1]?.field],
          [reOrderedList[2]?.header ? reOrderedList[2].header : ""] : item[reOrderedList[2]?.field],
          [reOrderedList[3]?.header ? reOrderedList[3].header : ""] : item[reOrderedList[3]?.field],
          [reOrderedList[4]?.header ? reOrderedList[4].header : ""] : item[reOrderedList[4]?.field],
          [reOrderedList[5]?.header ? reOrderedList[5].header : ""] : item[reOrderedList[5]?.field],
          [reOrderedList[6]?.header ? reOrderedList[6].header : ""] : item[reOrderedList[6]?.field],
          [reOrderedList[7]?.header ? reOrderedList[7].header : ""] : item[reOrderedList[7]?.field],
          [reOrderedList[8]?.header ? reOrderedList[8].header : ""] : item[reOrderedList[8]?.field],
          [reOrderedList[9]?.header ? reOrderedList[9].header : ""] : item[reOrderedList[9]?.field],
          [reOrderedList[10]?.header ?reOrderedList[10].header: "" ] : item[reOrderedList[10]?.field],
          [reOrderedList[11]?.header ?reOrderedList[11].header: "" ] : item[reOrderedList[11]?.field],
      }
    });
  return modifiedData;
}
function objectIdFilter (dataList,IdName,SelectedoptionId){
  var data = dataList?.filter((item)=>{
    return item[IdName] === SelectedoptionId
  })
  return data;
}

function allMastersFilteration(data,list,Prop,FilterValue,returnValue){
  for(let i in data){
    data[i][Prop] = list.find((item)=>item.associatedId === data[i][FilterValue])?.[returnValue]
  }
  return data
}

// Used to Remove the Line Breaks
function trimLineBreakFromString(string){
  return string.replace(/(\r\n|\r|\n)/g, "");
} 

// Used to Remove White Spaces from the String
function removeWhiteSpaces(String){
  return String.replace(/\s/g, "")
}

// Using for Email Validation
function emailValidation (value){
  const emailReg = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+)+([;]([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+))*$/;
  // const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailReg.test(value)
}

function tokenGenerator() {
//   const payload = {
//     "username": "Fratelli",
//     "password": "FR@telL!"
//   }
//  return new Promise((resolve, reject) => {
//    let data = "", 
//      token = localStorage.getItem("token");
//    if (token) {
//      data = token;
//      resolve(data);
//    } else {
//      commonService.restCall({
//          url: `${config.apiUrl}${config.snapshot.tokenGenerate}`,
//          method: "POST",
//          headers: [ ],          
//          data: payload,
//        }).then((res) => {
//          localStorage.setItem("token", res.data);
//          resolve(data);
//        }).catch((e)=>{
//          console.log(e,"Error Token")
//        });
//    }
//  });
}

 export default commonService;
 
 
  // function focusEditCursor(pointer, element){
  //   // const pointer = e.target.selectionStart;
  //   // const element = e.target;
  //   window.requestAnimationFrame(() => {
  //     element.selectionStart = pointer;
  //     element.selectionEnd = pointer;
  //   });
  // }
 
 
  // e.persist();
  // commonService.focusEditCursor(e.target.selectionStart, e.target);
  // e.target.setSelectionRange(e.target.selectionStart,e.target.selectionEnd)
  